module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Thin.8cac18d2accc27f91728369bb904ea74.woff2";